const EVENT = "marsilya-open-auth";

export function openAuth(mode = "login") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { mode } }));
}

export function subscribeAuth(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => handler(event.detail || { mode: "login" });
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
